import React, { useState, useEffect } from "react";
import {
  TextField,
  ThemeProvider,
  createTheme,
  Autocomplete,
} from "@mui/material";
import { Fragment, useMemo, useRef } from "react";
import { common_axios } from "../../../App";
import { Form, Formik, useFormik, Field, FieldArray } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import DeleteIcon from "@mui/icons-material/Delete";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Link, withRouter } from "react-router-dom";
import RuleIcon from "@mui/icons-material/Rule";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
const SpamRules = () => {


  const customId1 = "custom-id-yess";
  // ...................................Formik..............................//
  const initialValues = {
    valuesand: "",
    valuesor: "",
    valuesaction: "",
    ruleName: "",
    description: "",
  };

  const validationSchema = yup.object({
    ruleName: yup
      .string()
      .min(3, "Please enter atleast 3 characters in RuleName")
      .nullable(),
  });
  const formik = useFormik({
    initialValues: initialValues,
    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validationSchema: validationSchema,
    onSubmit: (values) => {
      Post(values);
    },
  });
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });
  
  const [open, setOpen] = useState(false);
  const [Name, setName] = useState("");
  const [Name1, setName1] = useState("");
  const [Name2, setName2] = useState("");
  const [dataState1, setDataState1] = useState([]);
  const [dataState2, setDataState2] = useState([]);
  const [hideSkeleton, setHideSkeleton] = useState();
  const [hideSkeleton1, setHideSkeleton1] = useState();
  const [hideSkeleton2, setHideSkeleton2] = useState();
  const [accountcountryidData, setAccountCountryIdData] = useState([]);
  const [accountidvalue, setAccountIdValue] = useState();
  const [accountcountryid, setAccountCountryId] = useState("");
  const handleChangeCountryAccount = (e) => {
    setAccountCountryId(e.target.value);
  };
  const [rank, setRank] = useState("");
  const handleChangeRank = (e) => {
    setRank(e.target.value);
  };
  // console.log("index--", accountidvalue);
   console.log("lop", accountidvalue);
  const [andPopup1, setAndPopup1] = useState(undefined);
  const PopupModalAnd = useRef(null);
  const ModalAnd = async (index) => {
    await PopupModalAnd.current.click();
  };
  const PopupModalOr = useRef(null);
  const ModalOr = async (cell) => {
    await PopupModalOr.current.click();
  };
  const PopupModalAction = useRef(null);
  const ModalAction = async (cell) => {
    await PopupModalAction.current.click();
  };
  const [response, setResponse] = useState("1");
  const handleChange1 = (e) => {
    setResponse(e.target.value);
  };
  const [spam, setSpam] = useState([]);
  const [spamOr, setSpamOr] = useState([]);
  const [data, setData] = useState([]);
  const [dataState, setDataState] = useState([]);
  const [actionData, setActionData] = useState([]);
  const [conditionData1, setConditionData1] = useState([]);
  const [attribute1Index, setAtribute1Index] = useState(undefined);
  // console.log("kio", attribute1Index);
  const [mapArray, setMapArray] = useState([
    {
      attribute: null,
      operations: null,
      values: "",
      butt: "",
      messageSource: null,
    },
  ]);

 console.log("kio", mapArray);

  const [conditionData2, setConditionData2] = useState([]);
  const [attribute2Index, setAtribute2Index] = useState(undefined);
  // console.log("maparrauyy--", attribute2Index);
  const [conditionData3, setConditionData3] = useState([]);
  const [attribute3Index, setAtribute3Index] = useState(undefined);
  const [mapArray1, setMapArray1] = useState([
    {
      attribute: null,
      operations: null,
      values: "",
      butt: "",
      messageSource: null,
    },
  ]);
  const [mapArray2, setMapArray2] = useState([
    {
      attribute: null,
      operations: null,
      values: "",
      butt: "",
      messageSource: null,
    },
  ]);
  const Reset1 = () => {
    setResponse("1");
    setRank(null);
    // setResponse(null);
    setAccountCountryId(null);
    formik.handleReset();
    setMapArray([
      {
        attribute: null,
        operations: null,
        values: "",
        butt: "",
      },
    ]);
    setMapArray1([
      {
        attribute: null,
        operations: null,
        values: "",
        butt: "",
      },
    ]);
    setMapArray2([
      {
        attribute: null,
        operations: null,
        values: "",
        butt: "",
      },
    ]);
  };
  const [mapState, setMapState] = useState(false);
  const [mapState1, setMapState1] = useState(false);
  const [mapState2, setMapState2] = useState(false);
  const [indexTransfer, setIndexTransfer] = useState();
  const [indexTransfer1, setIndexTransfer1] = useState();
  const [indexTransfer2, setIndexTransfer2] = useState();
   console.log("map--", mapArray);
  // console.log("temp_arr--", mapArray);
  const addRule = () => {
    setAtribute1Index(undefined);
    let temp_arr = [...mapArray];
    let a = {
      attribute: null,
      operations: null,
      values: "",
      butt: "",
    };
    temp_arr.push(a);
    // console.log("0o9", temp_arr);
    const array21 = temp_arr?.map((d) => d?.attribute?.attribute);
    const notPresentInArray2 = spam.filter((value) => {
      return !array21.includes(value?.attribute);
    });
    setMapArray(temp_arr);
    setSpam(notPresentInArray2);
  };
  useEffect(() => {
    let x = [...conditionData1];
    // x.push(mapArray[attribute1Index]?.attribute?.rulesOperations);
    x[attribute1Index] = mapArray[attribute1Index]?.attribute?.rulesOperations;
    // console.log("first", x);
    if (mapState == true) {
      setConditionData1(x);
    }
  }, [mapArray[attribute1Index]?.attribute]);

  // useEffect(() => {
  //   setMapArray([...mapArray[attribute1Index], { operations: "" }]);
  // }, [mapArray[attribute1Index]?.attribute1]);

  // .....................................................................................//
  useEffect(() => {
    let x = [...conditionData2];
    // x.push(mapArray1[attribute2Index]?.attribute?.rulesOperations);
    x[attribute2Index] = mapArray1[attribute2Index]?.attribute?.rulesOperations;

    if (mapState1 == true) {
      setConditionData2(x);
    }
  }, [mapArray1[attribute2Index]?.attribute]);
  // ...............................................................................................//
  useEffect(() => {
    let x = [...conditionData3];
    // setConditionData1(map)
    x[attribute3Index] =
      mapArray2[attribute3Index]?.attribute?.actionOperations;

    // x.push(mapArray2[attribute3Index]?.attribute?.actionOperations);
    if (mapState2 == true) {
      // alert("hii");
      setConditionData3(x);
    }
    // setConditionData1(mapArray[attribute1Index]?.attribute?.rulesOperations);
    // setMapArray(mapArray[attribute1Index].attribute)
  }, [mapArray2[attribute3Index]?.attribute]);
  // .............................................................//
  let temp_arr1 = [...mapArray1];
  // console.log("temp_arr--", mapArray1);
  const addRule1 = () => {
    setAtribute2Index(undefined);
    let a = {
      attribute: null,
      operations: null,
      values: "",
      butt: "",
    };
    temp_arr1.push(a);
    // const array21 = temp_arr1?.map((d) => d?.attribute?.attribute);
    // const notPresentInArray2 = spamOr.filter((value) => {
    //   return !array21.includes(value?.attribute);
    // });
    // setMapArray(temp_arr);
    setMapArray1(temp_arr1);
    // setSpamOr(notPresentInArray2);
  };
  // ..................................................................//
  let temp_arr2 = [...mapArray2];
  // console.log("temp_arr--", mapArray2);
  const addRule2 = () => {
    setAtribute3Index(undefined);
    let a = {
      attribute: null,
      operations: null,
      values: "",
      butt: "",
    };
    temp_arr2.push(a);
    const array21 = temp_arr2?.map((d) => d?.attribute?.attribute);
    const notPresentInArray2 = actionData.filter((value) => {
      return !array21.includes(value?.attribute);
    });
    // setMapArray(temp_arr);
    setMapArray2(temp_arr2);
    setActionData(notPresentInArray2);
  };
  //.................................................................................//
  const first = (index) => {
    setAtribute1Index(index - 1);
    let temp_arraction = [...mapArray];
    const previousSecondElementOfTheArray = temp_arraction.filter(
      (val, indexx) => index != indexx
    );
    console.log(
      "IIIIIIII",
      index,
      previousSecondElementOfTheArray,
      temp_arraction
    );
    setMapArray(previousSecondElementOfTheArray);
  };
  const firstor = (index) => {
    setAtribute2Index(index );
    let temp_arror = [...mapArray1];
    const previousSecondElementOfTheArray = temp_arror.filter(
      (val, indexx) => index != indexx
    );
    console.log("IIIIIIII", index, previousSecondElementOfTheArray, temp_arror);
    setMapArray1(previousSecondElementOfTheArray);
  };
  const firstaction = (index) => {
    setAtribute3Index(index );
    let temp_arraction = [...mapArray2];
    const previousSecondElementOfTheArray = temp_arraction.filter(
      (val, indexx) => index != indexx
    );

    console.log(
      "IIIIIIII",
      index,
      previousSecondElementOfTheArray,
      temp_arraction
    );
    setMapArray2(previousSecondElementOfTheArray);
  };
  // ...................  . . GetAPI for AND OR Condition..................................//
  async function SpamGet() {
    // console.log("first");
    try {
      setHideSkeleton(true);
      const result = await common_axios(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get-spam/attributes`
      );
      if (result.data.statusDescription.statusCode == 200) {
        setSpam(result.data.attributes);
        setSpamOr(result.data.attributes);

        let temp_arr = [];

        setHideSkeleton(false);
      } else {
        setSpam([]);
        setSpamOr([]);
        // setOpen(false);
        setHideSkeleton(false);
        toast.error(result.data.statusDescription.statusdescription,{
          toastId: customId1,
          theme: "colored",
         });
      }
    } catch (error) {
      setHideSkeleton(false);
      toast.error("Please Check Your Network",{
        toastId: customId1,
        theme: "colored",
       });
    }
  }
  // ............................Get API For Action .........................................//
  async function ActionGet() {
    // console.log("first");
    try {
      setHideSkeleton(true);
      const result = await common_axios(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get-spam/action/attributes`
      );
      if (result.data.statusDescription.statusCode == 200) {
        setActionData(result.data.actionAttributes);
        let temp_arr = [];

        setHideSkeleton(false);
      } else {
        setActionData([]);
        // setOpen(false);
        setHideSkeleton(false);
        toast.error(result.data.statusDescription.statusdescription,{
          toastId: customId1,
          theme: "colored",
         });
      }
    } catch (error) {
      // setOpen(false);
      setHideSkeleton(false);
      toast.error("Please Check Your Network",{
        toastId: customId1,
        theme: "colored",
       });
    }
  }
  // ..................................API for PopUp AND data..............................//

  async function PopUpGet(index) {
    // console.log("first");
    let name;
    let name1 = await mapArray[index].attribute?.attribute.split(" ");
    for (let indexx = 0; indexx < name1.length; indexx++) {
      const element = name1[indexx];
      console.log(element);
      if (indexx == 0) {
        name = await mapArray[index].attribute?.attribute
          .split(" ")[0]
          .toLowerCase();
      } else {
        name += await element;
      }
    }
    setName(name);
    try {
      // setOpen(true);
      setHideSkeleton2(true);
      const result = await common_axios.post(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get/attributes/data`,
        {
          // flag: mapArray[attribute1Index].attribute?.attribute,
          flag: mapArray[index].attribute?.attribute,
          userId: accountidvalue?.userId,
          // userId: localStorage.getItem("UserId"),
          // approved: "1",
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        // let a = [...dataState];
        // a[index] = [result?.data?.senderId];

        // setDataState(a);
        // setIndexTransfer(index);

        //  await mapArray[index].attribute?.attribute.split(" ").forEach((e1, index) => {
        //     console.log("IIIII",e1)
        //     if (index == 0) {
        //       name = mapArray[index].attribute?.attribute
        //       .split(" ")[0]
        //       .toLowerCase();
        //     } else {
        //       name += e1;
        //     }
        //   });
        // setOpen(false);
        setHideSkeleton2(false);
        // console.log({ name, name1 });
        setDataState(result.data?.[name]);
        let a = [...dataState];
        a[index] = result?.data?.[name];
        // setDataState(a);
        // console.log("a--", name);
        setIndexTransfer(index);
      } else {
        // setOpen(false);
        setHideSkeleton2(false);
        toast.error(result.data.statusDescription.statusdescription,{
          toastId: customId1,
          theme: "colored",
         });
      }
    } catch (error) {
      setOpen(false);
      setHideSkeleton2(false);
      toast.error("Please Check Your Network",{
        toastId: customId1,
        theme: "colored",
       });
    }
  }
  // ..................................API for PopUp OR data..............................//
  async function PopUpOr(index) {
    // console.log("first");
    try {
      let name1;
      let name11 = await mapArray1[index].attribute?.attribute.split(" ");
      for (let indexx = 0; indexx < name11.length; indexx++) {
        const element = name11[indexx];
        console.log(element);
        if (indexx == 0) {
          name1 = await mapArray1[index].attribute?.attribute
            .split(" ")[0]
            .toLowerCase();
        } else {
          name1 += await element;
        }
      }
      setName1(name1);
      setHideSkeleton2(true);
      const result = await common_axios.post(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get/attributes/data`,
        {
          flag: mapArray1[attribute2Index]?.attribute?.attribute,
          userId: localStorage.getItem("UserId"),
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        // setActionData(result.data.actionAttributes);
        // let name1;
        // mapArray1[index]?.attribute?.attribute
        //   .split(" ")
        //   .forEach((e1, index) => {
        //     if (index == 0)
        //       name1 = mapArray1[index]?.attribute?.attribute
        //         .split(" ")[0]
        //         .toLowerCase();
        //     else {
        //       name1 += e1;
        //     }
        //   });
        // setName1(name1);
        setDataState1(result.data?.[name1]);
        let a = [...dataState1];
        a[index] = result?.data?.[name1];
        // setDataState1(a);
        // console.log("a--", a);

        setIndexTransfer1(index);
        setHideSkeleton2(false);
      } else {
        setActionData([]);
        // setOpen(false);
        setHideSkeleton2(false);
        toast.error(result.data.statusDescription.statusdescription,{
          toastId: customId1,
          theme: "colored",
         });
      }
    } catch (error) {
      // setOpen(false);
      setHideSkeleton2(false);
      toast.error("Please Check Your Network",{
        toastId: customId1,
        theme: "colored",
       });
    }
  }
  // ..................................API for PopUp Action data..............................//
  async function PopUpAction(index) {
    // console.log("first");
    try {
      let name2;
      let name12 = await mapArray2[index].attribute?.attribute.split(" ");
      for (let indexx = 0; indexx < name12.length; indexx++) {
        const element = name12[indexx];
        console.log(element);
        if (indexx == 0) {
          name2 = await mapArray2[index].attribute?.attribute
            .split(" ")[0]
            .toLowerCase();
        } else {
          name2 += await element;
        }
      }
      setName2(name2);
      setHideSkeleton2(true);
      const result = await common_axios.post(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get/attributes/data`,
        {
          flag: mapArray2[attribute3Index].attribute?.attribute,
          userId: localStorage.getItem("UserId"),
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        // setActionData(result.data.actionAttributes);
        // let name2;
        // mapArray2[index].attribute?.attribute
        //   .split(" ")
        //   .forEach((e1, index) => {
        //     if (index == 0)
        //       name2 = setMapArray2[index].attribute?.attribute
        //         .split(" ")[0]
        //         .toLowerCase();
        //     else {
        //       name2 += e1;
        //     }
        //   });
        // setName2(name2);
        // let a = [];
        // a[index] = result?.data?.[name2];
        // setDataState2(a);
        // console.log("a--", a);
        // setIndexTransfer2(index);
        setHideSkeleton2(false);
        setDataState2(result.data?.[name2]);
        let a = [...dataState2];
        a[index] = result?.data?.[name2];
        // setDataState1(a);
        // console.log("a--", a);

        setIndexTransfer2(index);
      } else {
        setActionData([]);
        // setOpen(false);
        setHideSkeleton2(false);
        toast.error(result.data.statusDescription.statusdescription,{
          toastId: customId1,
          theme: "colored",
         });
      }
    } catch (error) {
      // setOpen(false);
      setHideSkeleton2(false);
      toast.error("Please Check Your Network",{
        toastId: customId1,
        theme: "colored",
       });
    }
  }
  // ..................................API for AccountId data..............................//
  async function AccountId() {
    // console.log("first");
    try {
      setHideSkeleton1(true);
      const result = await common_axios.post(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get/attributes/data`,
        {
          flag: accountcountryid,
          // flag: mapArray[index].attribute?.attribute,
          // // "userId":136
          // userId: localStorage.getItem("UserId"),
          // approved: "1",
          // accountId:"130"
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        setHideSkeleton1(false);
        setAccountCountryIdData(result.data.accountId);
      } else {
        setHideSkeleton1(false);
        toast.error(result.data.statusDescription.statusdescription,{
          toastId: customId1,
          theme: "colored",
         });
      }
    } catch (error) {
      // setOpen(false);
      setHideSkeleton1(false);
      toast.error("Please Check Your Network",{
        toastId: customId1,
        theme: "colored",
       });
    }
  }
  useEffect(() => {
    SpamGet();
    ActionGet();
    // SpamOrGet();
  }, []);

  useEffect(() => {
    if (accountcountryid != "" && accountcountryid != null) {
      AccountId();
    }
  }, [accountcountryid]);
  // .................................Post API......................................................//
  const Post = async (values) => {
    // console.log("x--", mapArray1[attribute2Index]?.attribute);
    setOpen(true);

    try {
      let arrAnd = [];

      for (let i = 0; i < mapArray?.length; i++) {
        if (mapArray[i]?.attribute?.attribute != "Message Source") {
          if (
            mapArray[i]?.attribute != null &&
            mapArray[i]?.operations != null &&
            mapArray[i]?.values != ""
          ) {
            let obj = {
              // values: "",
              // attribute: null,
              // operations: null,
            };
            console.log(mapArray?.[i]?.values);
            let element = mapArray?.[i];
            console.log("element--", element);
            obj.values = element?.values;
            obj.operations = element?.operations?.operations;
            // obj.operations =
            //   element?.operations == null ? null : element?.operations?.operations;
            obj.attribute = element?.attribute?.attribute;
            // obj.attribute =
            //   element?.attribute == null ? null : element?.attribute?.attribute;
            arrAnd.push(obj);
          }
        } else {
          // alert("else");
          if (
            mapArray[i]?.attribute != null &&
            mapArray[i]?.operations != null &&
            // mapArray[i]?.values != ""
            mapArray[i]?.messageSource != null
          ) {
            let obj = {
              // values: "",
              // attribute: null,
              // operations: null,
            };
            console.log(mapArray?.[i]?.values);
            let element = mapArray?.[i];
            console.log("element--", element);
            // obj.values = element?.values;
            obj.values = element?.messageSource;
            obj.operations = element?.operations?.operations;
            // obj.operations =
            //   element?.operations == null ? null : element?.operations?.operations;
            obj.attribute = element?.attribute?.attribute;
            // obj.attribute =
            //   element?.attribute == null ? null : element?.attribute?.attribute;
            arrAnd.push(obj);
          }
        }
      }
      // console.log("arrand--", arrAnd);
      let arrOr = [];
      for (let i = 0; i < mapArray1?.length; i++) {
        if (mapArray1[i]?.attribute?.attribute != "Message Source") {
          if (
            mapArray1[i]?.attribute != null &&
            mapArray1[i]?.operations != null &&
            mapArray1[i]?.values != ""
          ) {
            let obj2 = {
              // values: null,
              // attribute: null,
              // operations: null,
            };
            // console.log(mapArray1[i]?.values);
            let element = mapArray1?.[i];
            obj2.values = element?.values;
            obj2.operations = element?.operations?.operations;
            // obj2.operations =
            //   element?.operations == null ? null : element?.operations?.operations;
            obj2.attribute = element?.attribute?.attribute;
            arrOr.push(obj2);
          }
        } else {
          if (
            mapArray1[i]?.attribute != null &&
            mapArray1[i]?.operations != null &&
            // mapArray[i]?.values != ""
            mapArray1[i]?.messageSource != null
          ) {
            let obj2 = {
              // values: "",
              // attribute: null,
              // operations: null,
            };
            console.log(mapArray1?.[i]?.values);
            let element = mapArray1?.[i];
            console.log("element--", element);
            // obj.values = element?.values;
            obj2.values = element?.messageSource;
            obj2.operations = element?.operations?.operations;
            // obj.operations =
            //   element?.operations == null ? null : element?.operations?.operations;
            obj2.attribute = element?.attribute?.attribute;
            // obj.attribute =
            //   element?.attribute == null ? null : element?.attribute?.attribute;
            arrOr.push(obj2);
          }
        }
      }

      // console.log("arrAnd--", arrAnd);
      let arrAction = [];
      for (let i = 0; i < mapArray2?.length; i++) {
        if (mapArray2[i]?.attribute?.attribute != "Message Source") {
          if (
            mapArray2[i]?.attribute != null &&
            mapArray2[i]?.operations != null &&
            mapArray2[i]?.values != ""
          ) {
            let obj1 = {};
            // console.log(mapArray2[i].values);
            let element = mapArray2?.[i];
            obj1.values = element?.values;
            obj1.operations = element?.operations?.operations;
            obj1.attribute = element?.attribute?.attribute;
            arrAction.push(obj1);
            // console.log(mapArray2[i]?.values);
          }
        } else {
          // alert("else");
          if (
            mapArray2[i]?.attribute != null &&
            mapArray2[i]?.operations != null &&
            mapArray2[i]?.values != ""
          ) {
            let obj1 = {
              // values: "",
              // attribute: null,
              // operations: null,
            };
            console.log(mapArray2?.[i]?.values);
            let element = mapArray2?.[i];
            console.log("element--", element);
            // obj.values = element?.values;
            obj1.values = element?.messageSource;
            obj1.operations = element?.operations?.operations;
            // obj.operations =
            //   element?.operations == null ? null : element?.operations?.operations;
            obj1.attribute = element?.attribute?.attribute;
            // obj.attribute =
            //   element?.attribute == null ? null : element?.attribute?.attribute;
            arrOr.push(obj1);
          }
        }
      }
      console.log("arrOr--", arrAction);
      // setHideSkeleton(true);

      const result = await common_axios.post(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/spam`,
        {
          ruleName: values.ruleName,
          status: response,
          userId: accountidvalue?.userId,
          priority: rank,
          description: values.description,
          and: arrAnd.length == 0 ? null : arrAnd,
          or: arrOr.length == 0 ? null : arrOr,
          actionRequests: arrAction,
        },
        {
          headers: {
            username: localStorage.getItem("Username"),
          },
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        SpamGet();
        ActionGet();
        setRank(null);
        setResponse("1");
        setAccountCountryId(null);
        formik.handleReset();
        setAtribute1Index(undefined);
        setAtribute2Index(undefined);
        setAtribute3Index(undefined);
        // setAccountCountryId(null);
        setMapArray([
          {
            attribute: null,
            operations: null,
            values: "",
            butt: "",
          },
        ]);
        setMapArray1([
          {
            attribute: null,
            operations: null,
            values: "",
            butt: "",
          },
        ]);
        setMapArray2([
          {
            attribute: null,
            operations: null,
            values: "",
            butt: "",
          },
        ]);
        toast.success("Success!",{
          toastId: customId1,
          theme: "colored",
         });
      } else {
        setOpen(false);

        toast.error(result.data.statusDescription.statusdescription,{
          toastId: customId1,
          theme: "colored",
         });
      }
      // else if (
      //   mapArray1[attribute2Index]?.attribute != null &&
      //  mapArray1[attribute2Index]?.operations != null &&
      //   mapArray1[attribute2Index]?.values != "" &&
      //   mapArray[attribute2Index]?.attribute == null &&
      //   mapArray[attribute2Index]?.operations == null &&
      //   mapArray[attribute2Index]?.values == ""
      // ) {
      //   const result = await common_axios.post(
      //     // "http://192.168.167.66:5002/v1/get-rules"
      //     `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/spam`,
      //     {
      //       ruleName: "kfdhjkfh",
      //       userId: "130",
      //       priority: "1",
      //       description: "fdkhifrhk",
      //       or: arrOr,
      //       actionRequest: arrAction,
      //     },
      //     {
      //       headers: {
      //         username: localStorage.getItem("Username"),
      //       },
      //     }
      //   );
      //   if (result.data.statusDescription.statusCode == 200) {
      //     toast.success("Success!", {
      //       theme: "colored",
      //     });
      //   } else {
      //     toast.error(result.data.statusDescription.statusdescription);
      //   }
      // }
    } catch (error) {
      setOpen(false);
      setHideSkeleton(false);
      console.log("errors--", error);
      toast.error("Please Check Your Network");
    }
  };
  // function CustomClearIndicator(props) {
  //   return null; // this will hide the clear indicator
  // }

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
        <div>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-sm-12 mb-xl-0 mb-4">
              <div class="card mb-3 mt-4">
                <div class="card-header p-3 pt-2">
                  <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                    <i
                      class="material-icons ttl_icon  opacity-10 rule"
                      style={{ fontSize: "unset" }}
                    >
                      <RuleIcon style={{ fontSize: "28px" }} />
                    </i>
                  </div>
                  <div class="pt-1 marginleft_0">
                    <p class="text-sm mb-0 text-capitalize fw-bold">NEW RULE</p>
                    {/* <p className="text-sm mb-0  text d-inline-block float-end">
                      To add a new condition press
                      <span className="text-danger fw-bold">+</span> this button
                    </p> */}
                  </div>
                </div>
                <ThemeProvider theme={theme}>
                  <div class="card-body mt-4">
                    <form
                      onSubmit={formik.handleSubmit}
                      role="form"
                      className="text-start"
                    >
                      <div className="card shadow-none border bg_blue mb-5">
                        <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                          ADD NEW RULE
                        </span>
                        <div className="card-body">
                          <h3 class="spam_create">Add Exception </h3>
                          <div className="row mt-4">
                            <div className="col-md-3">
                              <TextField
                                autoComplete="on"
                                className="w-100"
                                type="text"
                                label="RuleName"
                                name="ruleName"
                                variant="outlined"
                                size="small"
                                required
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Tooltip
                                        title="RuleName"
                                        placement="top"
                                        arrow
                                        sx={{ color: "#85CBF2" }}
                                      >
                                        <InfoIcon />
                                      </Tooltip>
                                    </InputAdornment>
                                  ),
                                }}
                                onChange={formik.handleChange}
                                value={formik.values.ruleName}
                                error={
                                  formik.touched.ruleName &&
                                  Boolean(formik.errors.ruleName)
                                }
                                helperText={
                                  formik.touched.ruleName &&
                                  formik.errors.ruleName
                                }
                              />
                            </div>

                            <div className="col-md-2">
                              <FormControl required fullWidth size="small">
                                <InputLabel id="demo-simple-select-autowidth-label">
                                  Section Type
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-autowidth-label"
                                  id="demo-simple-select-autowidth"
                                  value={accountcountryid}
                                  onChange={handleChangeCountryAccount}
                                  // autowidth
                                  label="Section Type"
                                >
                                  {/* <MenuItem value={0}>Country Id</MenuItem> */}
                                  <MenuItem value="Account Id">
                                    Account Id
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                            {accountcountryid == "Account Id" && (
                              <>
                                {hideSkeleton1 == true ? (
                                  <>
                                    {" "}
                                    <Box sx={{ width: 200 }}>
                                      <Skeleton />
                                      <Skeleton animation="wave" />
                                    </Box>
                                  </>
                                ) : (
                                  <>
                                    <div className="col-md-2">
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={accountcountryidData}
                                        getOptionLabel={(option) =>
                                          option?.userName || ""
                                        }
                                        // value={accountidvalue}
                                        // onChange={handleChange12}
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setAccountIdValue(value);
                                          // setAccountCountryId(value);
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Account Id "
                                          />
                                        )}
                                      />
                                    </div>
                                  </>
                                )}
                              </>
                            )}

                            <div className="col-md-2">
                              <FormControl required fullWidth size="small">
                                <InputLabel id="demo-simple-select-autowidth-label">
                                  Rank
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-autowidth-label"
                                  id="demo-simple-select-autowidth"
                                  value={rank}
                                  onChange={handleChangeRank}
                                  autowidth
                                  label="Rank"
                                >
                                  {/* <MenuItem value={0}>Country Id</MenuItem> */}
                                  <MenuItem value={1}>1</MenuItem>
                                  <MenuItem value={2}>2</MenuItem>
                                  <MenuItem value={3}>3</MenuItem>
                                  <MenuItem value={4}>4</MenuItem>
                                  <MenuItem value={5}>5</MenuItem>
                                  <MenuItem value={6}>6</MenuItem>
                                  <MenuItem value={7}>7</MenuItem>
                                  <MenuItem value={8}>8</MenuItem>
                                  <MenuItem value={9}>9</MenuItem>
                                  <MenuItem value={10}>10</MenuItem>
                                  <MenuItem value={11}>11</MenuItem>
                                  <MenuItem value={12}>12</MenuItem>
                                  <MenuItem value={13}>13</MenuItem>
                                  <MenuItem value={14}>14</MenuItem>
                                  <MenuItem value={15}>15</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                            <div className="col-md-2">
                              <FormControl required fullWidth size="small">
                                <InputLabel id="demo-simple-select-autowidth-label">
                                  Status
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-autowidth-label"
                                  id="demo-simple-select-autowidth"
                                  value={response}
                                  onChange={handleChange1}
                                  // autowidth
                                  label="Status"
                                >
                                  <MenuItem value={1}>Activate</MenuItem>
                                  <MenuItem value={0}>Deactivate</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-md-4 ">
                              <TextareaAutosize
                                //  disabled
                                className={
                                  formik.errors.message
                                    ? "border-color-red w-100"
                                    : "w-100  textarea_8"
                                }
                                textarea_8
                                aria-label="empty textarea"
                                placeholder="Enter Description here"
                                name="description"
                                style={{
                                  width: " 300px",
                                  minHeight: "50px",
                                  borderColor: " #48a8dd",
                                }}
                                maxlength="100"
                                // value={ruleview}
                                // required
                                onChange={formik.handleChange}
                                value={formik.values.description}
                                error={
                                  formik.touched.description &&
                                  Boolean(formik.errors.description)
                                }
                                helperText={
                                  formik.touched.description &&
                                  formik.errors.description
                                }
                              />
                              <code className="d-flex align-items-center justify-content-between">
                                <p className="text" style={{ color: "#000" }}>
                                  Maximum Character length 100
                                </p>
                                <p
                                  className="text-end"
                                  style={{ color: "#000" }}
                                >
                                  Character length used:
                                  {formik.values.description.length}
                                </p>
                              </code>
                            </div>
                          </div>
                          {formik.values.ruleName == "" ||
                          accountcountryid == "" ||
                          
                          accountcountryid == null ||
                          accountidvalue == null ||
                          rank == "" ||
                          rank == null ||
                          response === "" ||
                          response == null ? (
                            <></>
                          ) : (
                            <>
                              <div className="card-body px-0 text-lg-start text-center">
                                {/* ..............................AND Condition...................................... */}
                                <div className="my-5">
                                  <h3 class="spam_create">
                                    Conditions{" "}
                                    <span class="">
                                      (Match all of the below)
                                    </span>
                                  </h3>
                                  <div className="mt-3">
                                    {/* {mapArray?.map((data, index) => { */}
                                    {mapArray?.map((data, index) => {
                                      console.log("hh", data);
                                      return (
                                        <>
                                          <div
                                            className="row my-4"
                                            id="cross_row"
                                          >
                                            {hideSkeleton == true ? (
                                              <>
                                                <Box sx={{ width: "15%" }}>
                                                  <Skeleton />
                                                  <Skeleton animation="wave" />
                                                  {/* <Skeleton animation={false} /> */}
                                                </Box>
                                              </>
                                            ) : (
                                              <>
                                                <div
                                                  className="col-md-2"
                                                  id={
                                                    mapArray?.length - 1 !=
                                                    index
                                                      ? "col_opacity1"
                                                      : ""
                                                  }
                                                >
                                                  <>
                                                    {/* <Autocomplete
                                                      disablePortal
                                                      // disabled={
                                                      //   formik.values.ruleName == ""
                                                      //   ||
                                                      //   accountcountryid ==""
                                                      //   ||
                                                      //   accountidvalue==null  ||
                                                      //   response==""||
                                                      //   formik.values.description
                                                      //   ==""
                                                      //        }
                                                      aria-required={
                                                        attribute1Index !=
                                                        undefined
                                                      }
                                                      className="w-100"
                                                      id="combo-box-demo"
                                                      size="small"
                                                      options={spam}
                                                      getOptionLabel={(
                                                        option
                                                      ) => option?.attribute}
                                                      value={data?.attribute}
                                                      setAtribute3Index
                                                      onChange={(e, val) => {
                                                        console.log(e);
                                                        if (val) {
                                                          console.log(
                                                            "value--",
                                                            val
                                                          );

                                                          let temp_arr = [
                                                            ...mapArray,
                                                          ];
                                                          temp_arr[
                                                            index
                                                          ].operations = null;
                                                          temp_arr[
                                                            index
                                                          ].attribute = val;
                                                          setMapArray(temp_arr);
                                                          let temp_arraction1 =
                                                            [...spam];

                                                          console.log({ val });
                                                          temp_arraction1 =
                                                            temp_arraction1.filter(
                                                              (d) =>
                                                                d.attribute !=
                                                                val.attribute
                                                            );
                                                          setSpam(
                                                            temp_arraction1
                                                          );
                                                          setAtribute1Index(
                                                            index
                                                          );
                                                          setMapState(true);
                                                        } else {
                                                          //  alert("else")
                                                          let temp_arr = [
                                                            ...mapArray,
                                                          ];
                                                          let temp_arraction1 =
                                                            [...spam];
                                                          temp_arraction1?.push(
                                                            temp_arr[index]
                                                              ?.attribute
                                                          );
                                                          temp_arr[
                                                            index
                                                          ].attribute = null;
                                                          temp_arr[
                                                            index
                                                          ].operations = null;
                                                          console.log({ val });
                                                          setMapArray(temp_arr);
                                                          setSpam(
                                                            temp_arraction1
                                                          );
                                                        }
                                                      }}
                                                      sx={{ width: 150 }}
                                                      renderInput={(params) => (
                                                        <TextField
                                                          required={
                                                            attribute1Index !=
                                                            undefined
                                                          }
                                                          {...params}
                                                          label="Select Column Name"
                                                        />
                                                      )}
                                                    /> */}

                                                    {/* <Autocomplete
                                                      disablePortal
                                                      aria-required={
                                                        attribute1Index !=
                                                        undefined
                                                      }
                                                      className="w-100"
                                                      id="combo-box-demo"
                                                      size="small"
                                                      options={spam}
                                                      getOptionLabel={(
                                                        option
                                                      ) => option?.attribute}
                                                      value={data?.attribute}
                                                      setAtribute3Index
                                                      onChange={(e, val) => {
                                                        
                                                        console.log(e);

                                                        console.log(
                                                          "value--",
                                                          val
                                                        );

                                                        let temp_arr = [
                                                          ...mapArray,
                                                        ];
                                                        temp_arr[
                                                          index
                                                        ].operations = null;
                                                        temp_arr[
                                                          index
                                                        ].attribute = val;
                                                        setMapArray(temp_arr);
                                                        let temp_arraction1 = [
                                                          ...spam,
                                                        ];
                                                        console.log({ val });
                                                        temp_arraction1 =
                                                          temp_arraction1.filter(
                                                            (d) =>
                                                              d.attribute !=
                                                              val.attribute
                                                          );
                                                        setAtribute1Index(
                                                          index
                                                        );
                                                        setMapState(true);
                                                      }}
                                                      sx={{ width: 150 }}
                                                      renderInput={(params) => (
                                                        <TextField
                                                          required={
                                                            attribute1Index !=
                                                            undefined
                                                          }
                                                          {...params}
                                                          label="Select Column Name"
                                                        />
                                                      )}
                                                    />  */}

                                                    <Autocomplete
                                                      disablePortal
                                                      aria-required={
                                                        attribute1Index !=
                                                        undefined
                                                      }
                                                      disabled={
                                                        mapArray?.length - 1 !=
                                                        index
                                                      }
                                                      className="w-100"
                                                      id="combo-box-demo"
                                                      size="small"
                                                      options={spam}
                                                      getOptionLabel={(
                                                        option
                                                      ) => option?.attribute}
                                                      value={data?.attribute}
                                                      setAtribute3Index
                                                      onChange={(e, val) => {
                                                        if (!val) {
                                                          //  alert("else")
                                                          let temp_arr = [
                                                            ...mapArray,
                                                          ];
                                                          // let temp_arraction1 =
                                                          //   [...spam];
                                                          // temp_arraction1?.push(
                                                          //   temp_arr[index]
                                                          //     ?.attribute
                                                          // );
                                                          temp_arr[
                                                            index
                                                          ].attribute = null;
                                                          temp_arr[
                                                            index
                                                          ].operations = null;
                                                          console.log({ val });
                                                          setMapArray(temp_arr);
                                                          // setSpam(
                                                          //   temp_arraction1
                                                          // );
                                                        } else {
                                                          let temp_arr = [
                                                            ...mapArray,
                                                          ];
                                                          temp_arr[
                                                            index
                                                          ].operations = null;
                                                          temp_arr[
                                                            index
                                                          ].attribute = val;
                                                          setMapArray(temp_arr);
                                                          // let temp_arraction1 =
                                                          //   [...spam];
                                                          // console.log({ val });
                                                          // temp_arraction1 =
                                                          // temp_arraction1.filter(
                                                          //   (d) =>
                                                          //     d.attribute !=
                                                          //     val.attribute
                                                          // );
                                                          setAtribute1Index(
                                                            index
                                                          );
                                                          setMapState(true);
                                                        }
                                                      }}
                                                      sx={{ width: 150 }}
                                                      renderInput={(params) => (
                                                        <TextField
                                                          required={
                                                            attribute1Index !=
                                                            undefined
                                                          }
                                                          {...params}
                                                          label="Select Column Name"
                                                        />
                                                      )}
                                                    />
                                                  </>
                                                </div>
                                              </>
                                            )}
                                            <div
                                              className="col-md-2"
                                              id={
                                                data?.attribute == null ||
                                                mapArray?.length - 1 != index
                                                  ? "col_opacity1"
                                                  : ""
                                              }
                                            >
                                              <>
                                                <Autocomplete
                                                  disablePortal
                                                  aria-required={
                                                    attribute1Index != undefined
                                                  }
                                                  className="w-100"
                                                  id="combo-box-demo"
                                                  size="small"
                                                  disabled={
                                                    mapArray[index]
                                                      ?.attribute == null ||
                                                    mapArray?.length - 1 !=
                                                      index
                                                  }
                                                  // options={
                                                  //   conditionData1.length > 0
                                                  //     ? conditionData1[
                                                  //         attribute1Index + 1
                                                  //       ]
                                                  //     : []
                                                  // }
                                                  value={data?.operations}
                                                  options={
                                                    conditionData1?.length > 0
                                                      ? conditionData1[index]
                                                      : []
                                                  }
                                                  getOptionLabel={(option) =>
                                                    option?.operations
                                                  }
                                                  onChange={(e, val) => {
                                                    let temp_arraction = [
                                                      ...mapArray,
                                                    ];
                                                    temp_arraction[
                                                      index
                                                    ].operations = val;
                                                    setMapArray(temp_arraction);
                                                    // setAtribute1Index(index);
                                                  }}
                                                  // // onChange={(e, value) => handlechange(value)}
                                                  // onChange={(e, value) => {
                                                  //   setOperations1(value?.operations);
                                                  // }}
                                                  sx={{ width: 300 }}
                                                  renderInput={(params) => (
                                                    <TextField
                                                      // required
                                                      required={
                                                        attribute1Index !=
                                                        undefined
                                                      }
                                                      {...params}
                                                      label="Select Condition"
                                                    />
                                                  )}
                                                />
                                              </>
                                            </div>

                                            {mapArray[index]?.attribute
                                              ?.attribute ==
                                            "Message Source" ? (
                                              <>
                                                <div
                                                  id={
                                                    mapArray?.length - 1 !=
                                                    index
                                                      ? "col_opacity1"
                                                      : ""
                                                  }
                                                  className="col-md-2"
                                                >
                                                  <FormControl
                                                    sx={{ m: 0, minWidth: 180 }}
                                                    size="small"
                                                    // required
                                                    // required={attribute1Index!=undefined}
                                                  >
                                                    <InputLabel id="demo-simple-select-autowidth-label">
                                                      Select Values
                                                    </InputLabel>
                                                    <Select
                                                      labelId="demo-simple-select-autowidth-label"
                                                      id="demo-simple-select-autowidth"
                                                      disabled={
                                                        mapArray?.length - 1 !=
                                                        index
                                                      }
                                                      required={
                                                        mapArray[index]
                                                          ?.attribute
                                                          ?.attribute ==
                                                        "Message Source"
                                                      }
                                                      onChange={(e, val) => {
                                                        let temp_arraction = [
                                                          ...mapArray,
                                                        ];
                                                        temp_arraction[
                                                          index
                                                        ].messageSource =
                                                          e.target.value;
                                                        setMapArray(
                                                          temp_arraction
                                                        );
                                                        // setAtribute1Index(index);
                                                      }}
                                                      autowidth
                                                      label="Select Values"
                                                    >
                                                      <MenuItem value="1">
                                                        HTTP
                                                      </MenuItem>
                                                      <MenuItem value="0">
                                                        SMPP
                                                      </MenuItem>
                                                    </Select>
                                                  </FormControl>
                                                </div>
                                              </>
                                            ) : (
                                              <>
                                                <div
                                                  id={
                                                    mapArray?.length - 1 !=
                                                    index
                                                      ? "col_opacity1"
                                                      : ""
                                                  }
                                                  className="col-md-2"
                                                >
                                                  <TextField
                                                    //   disabled={
                                                    //   mapArray[index]?.operations == null
                                                    // }

                                                    autoComplete="on"
                                                    className="m-0 w-100"
                                                    type="text"
                                                    disabled={
                                                      mapArray?.length - 1 !=
                                                      index
                                                    }
                                                    label="Value"
                                                    name="values"
                                                    variant="outlined"
                                                    size="small"
                                                    // required={
                                                    //   attribute1Index !=
                                                    //     undefined ||
                                                    //   mapArray[index]?.attribute
                                                    //     ?.attribute !=
                                                    //     "Message Source"
                                                    // }
                                                    value={data.values}
                                                    onChange={(e) => {
                                                      let temp_arraction = [
                                                        ...mapArray,
                                                      ];
                                                      temp_arraction[
                                                        index
                                                      ].values = e.target.value;
                                                      setMapArray(
                                                        temp_arraction
                                                      );
                                                    }}
                                                    InputProps={{
                                                      endAdornment: (
                                                        <InputAdornment position="end">
                                                          <Tooltip
                                                            title="Value"
                                                            placement="top"
                                                            arrow
                                                            sx={{
                                                              color: "#85CBF2",
                                                            }}
                                                          >
                                                            <InfoIcon />
                                                          </Tooltip>
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                    // onChange={formik.handleChange}
                                                    // value={formik.values.values}
                                                    // error={
                                                    //   formik.touched.values &&
                                                    //   Boolean(formik.errors.values)
                                                    // }
                                                    // helperText={
                                                    //   formik.touched.values &&
                                                    //   formik.errors.values
                                                    // }
                                                  />
                                                  {/* {/ <span className="d-block">fgffgfgg</span> /} */}
                                                  {/* {/ </div> /} */}
                                                </div>
                                              </>
                                            )}

                                            <div className="col-md-2 my-auto">
                                              <div className="">
                                                {/* <a
                                            disabled={
                                              mapArray[index]?.attribute ==
                                                null ||
                                              accountidvalue == undefined
                                            }
                                            onClick={() => {
                                              ModalAnd(index);
                                              PopUpGet(index);
                                            }}
                                          >
                                            <PersonIcon />
                                          </a> */}

                                                <Link
                                                  className={
                                                    data?.attribute == null
                                                      ? "d-block w-100"
                                                      : "d-block pop_up w-100"
                                                  }
                                                  onClick={() => {
                                                    ModalAnd(index);
                                                    PopUpGet(index);
                                                  }}
                                                >
                                                  {data?.attribute?.attribute}
                                                </Link>
                                              </div>
                                            </div>
                                            {index != 0 && (
                                              <>
                                                <div className="col-md-1 d-flex">
                                                  <button
                                                    type="button"
                                                    // disabled={
                                                    //   mapArray?.length - 1 !=
                                                    //   index
                                                    // }
                                                    className="btn w-auto bg-gradient-primary py-0 m-0 me-auto bgdanger1 "
                                                    onClick={() => {
                                                      first(index);

                                                      //  alert("else")

                                                      let temp_arr = [
                                                        ...mapArray,
                                                      ];
                                                      let temp_arraction1 = [
                                                        ...spam,
                                                      ];
                                                      temp_arraction1?.push(
                                                        temp_arr[index ]  
                                                          ?.attribute
                                                      );
                                                      temp_arr[
                                                        index
                                                      ].attribute = null;
                                                      temp_arr[
                                                        index
                                                      ].operations = null;
                                                      // console.log({ val });

                                                      setSpam(temp_arraction1);
                                                    }}
                                                  >
                                                    <DeleteIcon />
                                                  </button>

                                     
                                
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </>
                                      );
                                    })}
                                    {/* <div className="col-md-3 mt-3"> */}
                                    {/* <button
                                    type="button"
                                    className="btn bg-gradient-primary w_btn m-0 me-3  bgcolor"
                                    // onClick={unhideCondition}
                                  >
                                    +
                                  </button> */}

                                    <button
                                      className="add-plus"
                                      // id="col_opacity1"
                                      id={
                                        mapArray[attribute1Index]?.attribute ==
                                          null ||
                                        mapArray[attribute1Index]?.operations ==
                                          null ||
                                        (mapArray[attribute1Index]?.values ==
                                          "" &&
                                          mapArray[attribute1Index]
                                            ?.messageSource == null)
                                          ? "col_opacity1"
                                          : ""
                                      }
                                      // id={
                                      //   mapArray[attribute1Index]?.attribute ==
                                      //     null ||
                                      //   mapArray[attribute1Index].values ==
                                      //   null ||
                                      //   mapArray[attribute1Index].values ==
                                      //   "Message Source"
                                      //     ? "col_opacity1"
                                      //     : ""
                                      // }
                                      type="button"
                                      // disabled={
                                      //   mapArray?.length == 5 || 
                                      //   attribute1Index === undefined ||
                                      //   mapArray[attribute1Index]?.attribute ==
                                      //     null ||
                                      //   mapArray[attribute1Index]?.operations ==
                                      //     null ||
                                      //   (mapArray[attribute1Index]?.values ==
                                      //     "" &&
                                      //     mapArray[attribute1Index]
                                      //       ?.messageSource == null)
                                      // }
                                      disabled={
                      mapArray?.length == 5 ||
                      (mapArray.length != 0
                        ? mapArray[mapArray?.length - 1]?.attribute == null ||
                          mapArray[mapArray?.length - 1]?.operations == null ||
                          (mapArray[mapArray?.length - 1]?.values == "" &&
                            mapArray[mapArray?.length - 1]?.messageSource ==
                              null)
                        : false)
                      // ||
                      // attribute1Index!=-1
                    }
                                      onClick={addRule}
                                    >
                                      {/* 
{mapArray[index]?.attribute?.attribute ==
                                      "Message Source"  */}
                                      Add+
                                    </button>
                                    {/* </div> */}
                                  </div>
                                </div>
                                {/* ..................................END OF AND Condition............................. */}

                                {/* ......................................OR Condition 2................................. */}
                                <div className="my-5">
                                  <h3 class="spam_create">
                                    Conditions
                                    <span class="">
                                      (Match any of the below)
                                    </span>
                                  </h3>
                                  {mapArray1?.map((data, index) => {
                                    return (
                                      <>
                                        <div
                                          className="row my-4"
                                          id="cross_row"
                                        >
                                          {hideSkeleton == true ? (
                                            <>
                                              <Box sx={{ width: "15%" }}>
                                                <Skeleton />
                                                <Skeleton animation="wave" />
                                                {/* <Skeleton animation={false} /> */}
                                              </Box>
                                            </>
                                          ) : (
                                            <>
                                              <div
                                                className="col-md-2"
                                                id={
                                                  mapArray1?.length - 1 != index
                                                    ? "col_opacity1"
                                                    : ""
                                                }
                                              >
                                                <>
                                                  <Autocomplete
                                                    // renderClear={null}
                                                    disablePortal
                                                    aria-required
                                                    disabled={
                                                      mapArray1?.length - 1 !=
                                                      index
                                                    }
                                                    // disabled={
                                                    //     formik.values.ruleName == ""
                                                    //     ||
                                                    //     accountcountryid ==""
                                                    //     ||
                                                    //     accountidvalue==null  ||
                                                    //     response==""||
                                                    //     formik.values.description
                                                    //     ==""
                                                    //          }
                                                    className="w-100"
                                                    id="combo-box-demo"
                                                    size="small"
                                                    options={spamOr}
                                                    getOptionLabel={(option) =>
                                                      option?.attribute
                                                    }
                                                    value={data?.attribute}
                                                    onChange={(e, val) => {
                                                      console.log(e);
                                                      console.log("value", val);
                                                      let temp_arr = [
                                                        ...mapArray1,
                                                      ];
                                                      temp_arr[
                                                        index
                                                      ].attribute = val;

                                                      temp_arr[
                                                        index
                                                      ].operations = null;
                                                      // let temp_arraction1 = [
                                                      //   ...spamOr,
                                                      // ];
                                                      // console.log({ val });
                                                      // temp_arraction1 =
                                                      //   temp_arraction1.filter(
                                                      //     (d) =.>
                                                      //       dattribute !=
                                                      //       val.attribute
                                                      //   );
                                                      // // setSpamOr(
                                                      // //   temp_arraction1
                                                      // // );

                                                      setMapArray1(temp_arr);
                                                      setAtribute2Index(index);
                                                      setMapState1(true);
                                                    }}
                                                    sx={{ width: 150 }}
                                                    renderInput={(params) => (
                                                      <TextField
                                                        // required
                                                        {...params}
                                                        label="Select Column Name"
                                                      />
                                                    )}
                                                  />
                                                </>
                                              </div>
                                            </>
                                          )}

                                          <div
                                            className="col-md-2"
                                            id={
                                              data?.attribute == null ||
                                              mapArray1?.length - 1 != index
                                                ? "col_opacity1"
                                                : ""
                                            }
                                          >
                                            <>
                                              {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                    Select Condition
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations1}
                                      onChange={handleChange13}
                                      autowidth
                                      label="Select Condition"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                              <Autocomplete
                                                disablePortal
                                                // aria-required
                                                className="w-100"
                                                id="combo-box-demo"
                                                size="small"
                                                // options={conditionData}
                                                // getOptionLabel={(option) =>
                                                //   option.operations
                                                // }
                                                // value={operations1}
                                                // // onChange={(e, value) => handlechange(value)}
                                                // onChange={(e, value) => {
                                                //   setOperations1(value?.operations);
                                                // }}
                                                disabled={
                                                  mapArray1[index]?.attribute ==
                                                    null ||
                                                  mapArray1?.length - 1 != index
                                                }
                                                options={
                                                  conditionData2?.length > 0
                                                    ? conditionData2[index]
                                                    : []
                                                }
                                                getOptionLabel={(option) =>
                                                  option?.operations
                                                }
                                                value={data?.operations}
                                                onChange={(e, val) => {
                                                  let temp_arracti2 = [
                                                    ...mapArray1,
                                                  ];
                                                  temp_arracti2[
                                                    index
                                                  ].operations = val;
                                                  setMapArray1(temp_arracti2);
                                                  // setAtribute1Index(index);
                                                }}
                                                sx={{ width: 300 }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    // required
                                                    {...params}
                                                    label="Select Condition"
                                                  />
                                                )}
                                              />
                                            </>
                                          </div>

                                          {mapArray1[index]?.attribute
                                            ?.attribute == "Message Source" ? (
                                            <>
                                              <div
                                                className="col-md-2"
                                                id={
                                                  mapArray1?.length - 1 != index
                                                    ? "col_opacity1"
                                                    : ""
                                                }
                                              >
                                                <FormControl
                                                  sx={{ m: 0, minWidth: 180 }}
                                                  size="small"
                                                  // required
                                                >
                                                  <InputLabel id="demo-simple-select-autowidth-label">
                                                    Select Values
                                                  </InputLabel>
                                                  <Select
                                                    labelId="demo-simple-select-autowidth-label"
                                                    id="demo-simple-select-2autowidth"
                                                    disabled={
                                                      mapArray1?.length - 1 !=
                                                      index
                                                    }
                                                    // value={viewId}
                                                    // onChange={handleChange}
                                                    // onChange={(e) => setViewId(e.target.value)}
                                                    onChange={(e, val) => {
                                                      let temp_arraction = [
                                                        ...mapArray1,
                                                      ];
                                                      temp_arraction[
                                                        index
                                                      ].messageSource =
                                                        e.target.value;
                                                      setMapArray1(
                                                        temp_arraction
                                                      );
                                                      // setAtribute1Index(index);
                                                    }}
                                                    autowidth
                                                    label="Select Values"
                                                  >
                                                    <MenuItem value="1">
                                                      HTTP
                                                    </MenuItem>
                                                    <MenuItem value="0">
                                                      SMPP
                                                    </MenuItem>
                                                  </Select>
                                                </FormControl>
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              <div
                                                className="col-md-2"
                                                id={
                                                  mapArray1?.length - 1 != index
                                                    ? "col_opacity1"
                                                    : ""
                                                }

                                                // id={
                                                //   data?.values === ""
                                                //     ? "col_opacity1"
                                                //     : ""
                                                // }
                                              >
                                                {/* {/ <div className="d-flex justify-content-between align-items-center"> /} */}
                                                <TextField
                                                  autoComplete="on"
                                                  className="m-0 w-100"
                                                  // disabled={
                                                  //   mapArray1[index]?.operations == null
                                                  // }
                                                  disabled={
                                                    mapArray1?.length - 1 !=
                                                    index
                                                  }
                                                  type="text"
                                                  label="Value"
                                                  name="values"
                                                  variant="outlined"
                                                  size="small"
                                                  // required
                                                  value={data.values}
                                                  onChange={(e) => {
                                                    let temp_arror = [
                                                      ...mapArray1,
                                                    ];
                                                    temp_arror[index].values =
                                                      e.target.value;
                                                    setMapArray1(temp_arror);
                                                  }}
                                                  InputProps={{
                                                    endAdornment: (
                                                      <InputAdornment position="end">
                                                        <Tooltip
                                                          title="Value"
                                                          placement="top"
                                                          arrow
                                                          sx={{
                                                            color: "#85CBF2",
                                                          }}
                                                        >
                                                          <InfoIcon />
                                                        </Tooltip>
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                  // onChange={formik.handleChange}
                                                  // value={formik.values.values}
                                                  // error={
                                                  //   formik.touched.values &&
                                                  //   Boolean(formik.errors.values)
                                                  // }
                                                  // helperText={
                                                  //   formik.touched.values &&
                                                  //   formik.errors.values
                                                  // }
                                                />
                                                {/* {/ <span className="d-block">fgffgfgg</span> /} */}
                                                {/* {/ </div> /} */}
                                              </div>
                                            </>
                                          )}

                                          <div className="col-md-2 my-auto">
                                            <div className="d-block">
                                              {/* <span className="d-block pop_up"> */}
                                              <Link
                                                className={
                                                  data?.attribute == null
                                                    ? "d-block w-100"
                                                    : "d-block pop_up w-100"
                                                }
                                                onClick={() => {
                                                  ModalOr(index);
                                                  PopUpOr(index);
                                                }}
                                              >
                                                {data?.attribute?.attribute}
                                              </Link>
                                              {/* <a
                                          disabled={
                                            mapArray1[index]?.attribute == null
                                          }
                                          onClick={() => {
                                            ModalOr(index);
                                            PopUpOr(index);
                                          }}
                                        >
                                          <PersonIcon />
                                        </a> */}
                                            </div>
                                          </div>
                                          {index != 0 && (
                                            <>
                                              <div className="col-md-1 d-flex">
                                                <button
                                                  type="button"
                                                  className="btn w-auto bg-gradient-primary m-0 py-0 me-auto bgdanger1 "
                                                  // disabled={
                                                  //   mapArray1?.length - 1 !=
                                                  //   index
                                                  // }
                                                  onClick={() => {
                                                    firstor(index);

                                                    let temp_arr = [
                                                      ...mapArray1,
                                                    ];
                                                    let temp_arraction1 = [
                                                      ...spamOr,
                                                    ];
                                                    temp_arraction1?.push(-1);
                                                    temp_arr[index].attribute =
                                                      null;
                                                    temp_arr[index].operations =
                                                      null;
                                                    // console.log({ val });
                                                    // setMapArray1(temp_arr);

                                                    setSpamOr(temp_arraction1);
                                                  }}
                                                >
                                                  <DeleteIcon />
                                                </button>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </>
                                    );
                                  })}
                                  <button
                                    className="add-plus mt-3"
                                    // id="col_opacity1"
                                    // id={
                                    //   mapArray1[attribute2Index]?.attribute ==
                                    //     null ||
                                    //   mapArray1[attribute2Index]?.operations ==
                                    //     null ||
                                    //   (mapArray1[attribute2Index]?.values ==
                                    //     "" &&
                                    //     mapArray1[attribute2Index]
                                    //       ?.messageSource == null)
                                    //     ? "col_opacity1"
                                    //     : ""
                                    // }

                                    id={
                      ( (mapArray1.length!=0 )?
                      mapArray1[mapArray1?.length - 1]?.attribute == null ||
                          mapArray1[mapArray1?.length - 1]?.operations == null ||
                          (mapArray1[mapArray1?.length - 1]?.values == "" &&
                            mapArray1[mapArray1?.length - 1]?.messageSource ==
                              null)
                        
                         :
                          false)
                        ? "col_opacity1"
                        : ""
                    }
                                    type="button"
                                    // disabled={
                                    //   mapArray1?.length == 5 ||
                                    //   attribute2Index === undefined ||
                                    //   mapArray1[attribute2Index]?.attribute ==
                                    //     null ||
                                    //   mapArray1[attribute2Index]?.operations ==
                                    //     null ||
                                    //   (mapArray1[attribute2Index]?.values ==
                                    //     "" &&
                                    //     mapArray1[attribute2Index]
                                    //       ?.messageSource == null)
                                    // }
                                    disabled={
                      mapArray1?.length == 5 ||
                      (mapArray1.length != 0
                        ? mapArray1[mapArray1?.length - 1]?.attribute == null ||
                          mapArray1[mapArray1?.length - 1]?.operations == null ||
                          (mapArray1[mapArray1?.length - 1]?.values == "" &&
                            mapArray1[mapArray1?.length - 1]?.messageSource ==
                              null)
                        : false)
                      // ||
                      // attribute1Index!=-1
                    }
                                    //  disabled={mapArray1?.length == 5}

                                    onClick={addRule1}
                                  >
                                    Add+
                                  </button>
                                </div>
                                {/*.....................................End Of Condition................................... */}
                                {/* </div> */}

                                {/* ...............................Action Condition 3.............................. */}

                                <h3 class="spam_create">Action</h3>

                                {mapArray2?.map((data, index) => {
                                  return (
                                    <>
                                      <div className="row my-4" id="cross_row">
                                        <div
                                          className="col-md-2"
                                          id={
                                            mapArray2?.length - 1 != index
                                              ? "col_opacity1"
                                              : ""
                                          }
                                        >
                                          {hideSkeleton == true ? (
                                            <>
                                              <Box sx={{ width: "100%" }}>
                                                <Skeleton />
                                                <Skeleton animation="wave" />
                                                {/* <Skeleton animation={false} /> */}
                                              </Box>
                                            </>
                                          ) : (
                                            <>
                                              <Autocomplete
                                                disablePortal
                                                aria-required
                                                disabled={
                                                  mapArray2?.length - 1 != index
                                                }
                                                // disabled={
                                                //       formik.values.ruleName == ""
                                                //       ||
                                                //       accountcountryid ==""
                                                //       ||
                                                //       accountidvalue==null  ||
                                                //       response==""||
                                                //       formik.values.description
                                                //       ==""
                                                //            }
                                                className="w-100"
                                                id="combo-box-demo"
                                                size="small"
                                                options={actionData}
                                                getOptionLabel={(option) =>
                                                  option?.attribute
                                                }
                                                value={data?.attribute}
                                                onChange={(e, val) => {
                                                  console.log(e);

                                                  let temp_arr = [...mapArray2];
                                                  let temp_arraction1 = [
                                                    ...actionData,
                                                  ];
                                                  temp_arr[index].attribute =
                                                    val;
                                                  temp_arr[index].operations =
                                                    null;
                                                  setMapArray2(temp_arr);
                                                  console.log({ val });
                                                  temp_arraction1 =
                                                    temp_arraction1.filter(
                                                      (d) =>
                                                        d.attribute !=
                                                        val.attribute
                                                    );
                                                  // setActionData(
                                                  //   temp_arraction1
                                                  // );

                                                  setAtribute3Index(index);
                                                  setMapState2(true);
                                                }}
                                                sx={{ width: 150 }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    required
                                                    {...params}
                                                    label="Select Action Name"
                                                  />
                                                )}
                                              />
                                            </>
                                          )}
                                        </div>
                                        <div
                                          className="col-md-2"
                                          id={
                                            data?.attribute == null ||
                                            mapArray2?.length - 1 != index
                                              ? "col_opacity1"
                                              : ""
                                          }
                                        >
                                          <>
                                            <Autocomplete
                                              disablePortal
                                              aria-required
                                              className="w-100"
                                              id="combo-box-demo"
                                              size="small"
                                              disabled={
                                                mapArray2[index]?.attribute ==
                                                  null ||
                                                mapArray2?.length - 1 != index
                                              }
                                              options={
                                                conditionData3?.length > 0
                                                  ? conditionData3[index]
                                                  : []
                                              }
                                              getOptionLabel={(option) =>
                                                option?.operations || ""
                                              }
                                              value={data?.operations}
                                              onChange={(e, val) => {
                                                let temp_arraction = [
                                                  ...mapArray2,
                                                ];
                                                temp_arraction[
                                                  index
                                                ].operations = val;
                                                setMapArray2(temp_arraction);
                                                // setAtribute1Index(index);
                                              }}
                                              sx={{ width: 300 }}
                                              renderInput={(params) => (
                                                <TextField
                                                  required
                                                  {...params}
                                                  label="Select Condition"
                                                />
                                              )}
                                            />
                                          </>
                                        </div>

                                        {mapArray2[index]?.attribute
                                          ?.attribute == "Message Source" ? (
                                          <>
                                            <div
                                              className="col-md-2"
                                              id={
                                                mapArray2?.length - 1 != index
                                                  ? "col_opacity1"
                                                  : ""
                                              }
                                            >
                                              <FormControl
                                                sx={{ m: 0, minWidth: 180 }}
                                                size="small"
                                                // required
                                                // required={attribute1Index!=undefined}
                                              >
                                                <InputLabel id="demo-simple-select-autowidth-label">
                                                  Select Values
                                                </InputLabel>
                                                <Select
                                                  labelId="demo-simple-select-autowidth-label"
                                                  id="demo-simple-select-autowidth"
                                                  disabled={
                                                    mapArray2?.length - 1 !=
                                                    index
                                                  }
                                                  required={
                                                    mapArray2[index]?.attribute
                                                      ?.attribute ==
                                                    "Message Source"
                                                  }
                                                  // value={viewId}
                                                  // onChange={handleChange}
                                                  // onChange={(e) => setViewId(e.target.value)}

                                                  onChange={(e, val) => {
                                                    let temp_arraction = [
                                                      ...mapArray2,
                                                    ];
                                                    temp_arraction[
                                                      index
                                                    ].messageSource =
                                                      e.target.value;
                                                    setMapArray2(
                                                      temp_arraction
                                                    );
                                                    // setAtribute1Index(index);
                                                  }}
                                                  autowidth
                                                  label="Select Values"
                                                >
                                                  <MenuItem value="1">
                                                    HTTP
                                                  </MenuItem>
                                                  <MenuItem value="0">
                                                    SMPP
                                                  </MenuItem>
                                                </Select>
                                              </FormControl>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <div
                                              className="col-md-2"
                                              id={
                                                mapArray2?.length - 1 != index
                                                  ? "col_opacity1"
                                                  : ""
                                              }

                                              //  id={
                                              //                                           data?.values == ""
                                              //                                             ? "col_opacity1"
                                              //                                             : ""
                                              //                                         }
                                            >
                                              {/* <div className="d-flex justify-content-between align-items-center"> */}
                                              <TextField
                                                // disabled={
                                                //         mapArray2[index]?.operations == null
                                                //       }
                                                autoComplete="on"
                                                className="m-0 w-100"
                                                disabled={
                                                  mapArray2?.length - 1 != index
                                                }
                                                type="text"
                                                label="Value"
                                                name="values"
                                                variant="outlined"
                                                size="small"
                                                required
                                                value={data.values}
                                                onChange={(e) => {
                                                  let temp_arraction = [
                                                    ...mapArray2,
                                                  ];
                                                  temp_arraction[index].values =
                                                    e.target.value;
                                                  setMapArray2(temp_arraction);
                                                }}
                                                InputProps={{
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Tooltip
                                                        title="Value"
                                                        placement="top"
                                                        arrow
                                                        sx={{
                                                          color: "#85CBF2",
                                                        }}
                                                      >
                                                        <InfoIcon />
                                                      </Tooltip>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                // onChange={formik.handleChange}
                                                // value={formik.values.values}
                                                // error={
                                                //   formik.touched.values &&
                                                //   Boolean(formik.errors.values)
                                                // }
                                                // helperText={
                                                //   formik.touched.values &&
                                                //   formik.errors.values
                                                // }
                                              />
                                            </div>
                                          </>
                                        )}

                                        <div className="col-md-2 my-auto">
                                          <div className="">
                                            <Link
                                              className={
                                                data?.attribute == null
                                                  ? "d-block w-100"
                                                  : "d-block pop_up w-100"
                                              }
                                              onClick={() => {
                                                ModalAction(index);
                                                PopUpAction(index);
                                              }}
                                            >
                                              {data?.attribute?.attribute}
                                            </Link>
                                            {/* <a
                                          disabled={
                                            mapArray2[index]?.attribute == null
                                          }
                                          // onClick={() => {
                                          //   ModalAction(index);
                                          //   // PopUpAction(index);
                                          // }}
                                        >
                                          <PersonIcon />
                                        </a> */}
                                          </div>
                                        </div>

                                        {index != 0 && (
                                          <>
                                            <div className="col-md-1 d-flex">
                                              <button
                                                type="button"
                                                className="btn w-auto bg-gradient-primary m-0 py-0 me-auto bgdanger1 "
                                                // disabled={
                                                //   mapArray2?.length - 1 != index
                                                // }
                                                onClick={() => {
                                                  firstaction(index);
                                                  let temp_arr = [...mapArray2];
                                                  let temp_arraction1 = [
                                                    ...actionData,
                                                  ];
                                                  temp_arraction1?.push(
                                                    temp_arr[index]
                                                      ?.attribute
                                                  );
                                                  temp_arr[index].attribute =
                                                    null;
                                                  temp_arr[index].operations =
                                                    null;

                                                  setActionData(
                                                    temp_arraction1
                                                  );
                                                }}
                                              >
                                                <DeleteIcon />
                                              </button>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </>
                                  );
                                })}
                                <button
                                  className="add-plus  mt-3"
                                  type="button"
                                  // id="col_opacity1"
                                  // id={
                                  //   mapArray2[attribute3Index]?.attribute ==
                                  //     null ||
                                  //   mapArray2[attribute3Index]?.operations ==
                                  //     null ||
                                  //   (mapArray2[attribute3Index]?.values == "" &&
                                  //     mapArray2[attribute3Index]
                                  //       ?.messageSource == null)
                                  //     ? "col_opacity1"
                                  //     : ""
                                  // }
                                  id={
                                    ( (mapArray2.length!=0 )?
                     mapArray2[mapArray2?.length - 1]?.attribute == null ||
                      mapArray2[mapArray2?.length - 1]?.operations == null ||
                      (mapArray2[mapArray2?.length - 1]?.values == "" &&
                        mapArray2[mapArray2?.length - 1]?.messageSource == null)
                        
                         :
                          false)
                                      ? "col_opacity1"
                                      : ""
                                  }

                                  disabled={
                      mapArray2?.length == 5 
                       ||
                      ( (mapArray2.length!=0 )
                      ? mapArray2[mapArray2?.length - 1]?.attribute == null ||
                          mapArray2[mapArray2?.length - 1]?.operations == null ||
                          (mapArray2[mapArray2?.length - 1]?.values == "" &&
                            mapArray2[mapArray2?.length - 1]?.messageSource ==
                              null)
                        
                         :
                          false)}
                          

                                  // disabled={mapArray2?.length == 5}
                                  // disabled={
                                  //   mapArray2?.length == 5 ||
                                  //   attribute3Index === undefined ||
                                  //   mapArray2[attribute3Index]?.attribute ==
                                  //     null ||
                                  //   mapArray2[attribute3Index]?.operations ==
                                  //     null ||
                                  //   (mapArray2[attribute3Index]?.values == "" &&
                                  //     mapArray2[attribute3Index]
                                  //       ?.messageSource == null)
                                  // }

                                  onClick={addRule2}
                                >
                                  Add+
                                </button>
                                {/*.........................End Of Action Condition 3................................. */}

                                <div class="mt-4 text-sm text-end">
                                  {/* <button
                                type="submit"
                                //  onClick={Post}
                              //   id={
                              //     mapArray[attribute1Index]?.attribute==null
                              //     ||
                              //     mapArray[attribute1Index]?.operations == null
                              //     ||
                              //     mapArray[attribute1Index]?.values == ""
                              //   ||
                              //   mapArray1[attribute2Index]?.attribute==null
                              //     ||
                              //     mapArray1[attribute2Index]?.operations == null
                              //     ||
                              //     mapArray1[attribute2Index]?.values == ""
                              //     ||
                              //   mapArray2[attribute3Index]?.attribute==null
                              //     ||
                              //     mapArray2[attribute3Index]?.operations == null
                              //     ||
                              //     mapArray2[attribute3Index]?.values == ""
                              //     ? "col_opacity1"
                              //     : ""
                              // }
                                className="btn bg-gradient-primary mt-4 me-4 w_btn"
                              //   disabled={
                                  
                              //    (attribute1Index!=undefined && mapArray[attribute1Index]?.attribute==null
                              //     ||
                              //     mapArray[attribute1Index]?.operations == null
                              //     ||
                              //     mapArray[attribute1Index]?.values == "")
                              //   ||
                              //  (attribute2Index!=undefined && mapArray1[attribute2Index]?.attribute==null
                              //     ||
                              //     mapArray1[attribute2Index]?.operations == null
                              //     ||
                              //     mapArray1[attribute2Index]?.values == "")
                              //     ||
                              //   (attribute3Index!=undefined && mapArray2[attribute3Index]?.attribute==null
                              //     ||
                              //     mapArray2[attribute3Index]?.operations == null
                              //     ||
                              //     mapArray2[attribute3Index]?.values == "")
                              //   }
                              >
                                Save
                                <i class="material-icons opacity-10">
                                  arrow_right_alt
                                </i>
                              </button> */}

                                  <button
                                    type="submit"
                                    //  onClick={Post}
                                    //   id={
                                    //     mapArray[attribute1Index]?.attribute==null
                                    //     ||
                                    //     mapArray[attribute1Index]?.operations == null
                                    //     ||
                                    //     mapArray[attribute1Index]?.values == ""
                                    //   ||
                                    //   mapArray1[attribute2Index]?.attribute==null
                                    //     ||
                                    //     mapArray1[attribute2Index]?.operations == null
                                    //     ||
                                    //     mapArray1[attribute2Index]?.values == ""
                                    //     ||
                                    //   mapArray2[attribute3Index]?.attribute==null
                                    //     ||
                                    //     mapArray2[attribute3Index]?.operations == null
                                    //     ||
                                    //     mapArray2[attribute3Index]?.values == ""
                                    //     ? "col_opacity1"
                                    //     : ""
                                    // }
                                    className="btn bg-gradient-primary mt-4 me-4 w_btn"
                                    disabled={
                                      (attribute1Index == undefined &&
                                        attribute2Index == undefined &&
                                        attribute3Index != undefined) ||
                                      (attribute1Index != undefined &&
                                        (mapArray[attribute1Index]?.attribute ==
                                          null ||
                                          mapArray[attribute1Index]
                                            ?.operations == null ||
                                          (mapArray[attribute1Index]?.values ==
                                            "" &&
                                            mapArray[attribute1Index]
                                              ?.messageSource == null))) ||
                                      (attribute2Index != undefined &&
                                        (mapArray1[attribute2Index]
                                          ?.attribute == null ||
                                          mapArray1[attribute2Index]
                                            ?.operations == null ||
                                          (mapArray1[attribute2Index]?.values ==
                                            "" &&
                                            mapArray1[attribute2Index]
                                              ?.messageSource == null))) ||
                                      (attribute3Index != undefined &&
                                        (mapArray2[attribute3Index]
                                          ?.attribute == null ||
                                          mapArray2[attribute3Index]
                                            ?.operations == null ||
                                          (mapArray2[attribute3Index]?.values ==
                                            "" &&
                                            mapArray2[attribute3Index]
                                              ?.messageSource == null))) ||
                                      (attribute1Index == undefined &&
                                        attribute2Index == undefined &&
                                        attribute3Index == undefined) ||
                                      (attribute2Index === undefined &&
                                        attribute1Index == undefined &&
                                        attribute3Index == undefined)
                                    }
                                  >
                                    Save
                                    <i class="material-icons opacity-10">
                                      arrow_right_alt
                                    </i>
                                  </button>
                                  <button
                                    // onClick={formik.resetForm}
                                    onClick={(e) => {
                                      Reset1();
                                      formik.resetForm(e);
                                    }}
                                    type="button"
                                    className="btn bg-gradient-secondary mt-4 w_btn"
                                  >
                                    Reset
                                    <SettingsBackupRestoreRoundedIcon
                                      style={{ fontSize: "17px" }}
                                    />
                                  </button>
                                </div>
                                {/* {andPopup1  undefined && ( */}
                                <div>
                                  <button
                                    ref={PopupModalAnd}
                                    type="button"
                                    className="btn btn-primary d-none"
                                    data-bs-toggle="modal"
                                    data-bs-target="#staticBackdrop1"
                                  >
                                    Launch static backdrop modal
                                  </button>

                                  <div
                                    className="modal fade"
                                    id="staticBackdrop1"
                                    data-bs-backdrop="static"
                                    data-bs-keyboard="false"
                                    tabindex="-1"
                                    aria-labelledby="staticBackdrop1Label"
                                    aria-hidden="true"
                                  >
                                    <div className="modal-dialog">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h5
                                            className="modal-title"
                                            id="staticBackdrop1Label"
                                          >
                                            List
                                          </h5>
                                          <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => {
                                              // alert("ii")
                                              setDataState([]);
                                            }}
                                          ></button>
                                        </div>

                                        {hideSkeleton2 == true ? (
                                          <>
                                            <Box sx={{ width: "100%" }}>
                                              <Skeleton />
                                              <Skeleton animation="wave" />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                            </Box>
                                          </>
                                        ) : (
                                          <>
                                            <div
                                              className="modal-body"
                                              style={{
                                                 height: "423px",
                                                overflow: "auto",
                                              }}
                                            >
                                              <div className="table-responsive">
                                                {Name == "accountId" && (
                                                  <>
                                                    <table className="table table-striped table-bordered dataTable table-sm">
                                                      <thead>
                                                        <tr role="row">
                                                          <th className="text-center width_2">
                                                            User Id
                                                          </th>
                                                          <th className="text-center width_2">
                                                            User Name
                                                          </th>
                                                        </tr>
                                                      </thead>

                                                      <tbody
                                                        id="dropdown-item"
                                                        role="rowgroup"
                                                      >
                                                        {dataState?.map(
                                                          (arg) => {
                                                            return (
                                                              <>
                                                                <tr role="row">
                                                                  <td>
                                                                    {
                                                                      arg?.userId
                                                                    }
                                                                  </td>
                                                                  <td>
                                                                    {
                                                                      arg?.userName
                                                                    }
                                                                  </td>
                                                                </tr>
                                                              </>
                                                            );
                                                          }
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </>
                                                )}
                                                {Name == "senderId" && (
                                                  <>
                                                    <div
                                                      className="modal-body"
                                                      style={{
                                                        // height: "423px",
                                                        overflow: "auto",
                                                      }}
                                                    >
                                                      {/* <div className="table-responsive"> */}
                                                      <table className="table table-striped table-bordered dataTable table-sm">
                                                        {dataState.length ==
                                                          0 && (
                                                          <h5 className="text-center mt-4">
                                                            Data Not Found
                                                          </h5>
                                                        )}
                                                        <thead>
                                                          <tr role="row">
                                                            <th className="text-center width_2">
                                                              Id
                                                            </th>
                                                            <th className="text-center width_2">
                                                              SenderId
                                                            </th>
                                                          </tr>
                                                        </thead>

                                                        <tbody
                                                          id="dropdown-item"
                                                          role="rowgroup"
                                                        >
                                                          {dataState?.map(
                                                            (arg) => {
                                                              return (
                                                                <>
                                                                  <tr role="row">
                                                                    <td>
                                                                      {arg.id}
                                                                    </td>
                                                                    <td>
                                                                      {
                                                                        arg?.senderId
                                                                      }
                                                                    </td>
                                                                  </tr>
                                                                </>
                                                              );
                                                            }
                                                          )}
                                                        </tbody>
                                                      </table>
                                                      {/* <div className="modal-footer justify-content-center">
                                              <button
                                                type="button"
                                                className="btn btn-primary editcolor shadow okbtn"
                                                data-bs-dismiss="modal"
                                              >
                                                Ok
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-secondary shadow"
                                                data-bs-dismiss="modal"
                                              >
                                                Cancel
                                              </button>
                                            </div> */}
                                                    </div>
                                                    {/* </div> */}
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                          </>
                                        )}

                                        {/* <div class="modal-footer"> */}

                                        {/* </div> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* ....................................................... */}
                                <div>
                                  <button
                                    ref={PopupModalOr}
                                    type="button"
                                    className="btn btn-primary d-none"
                                    data-bs-toggle="modal"
                                    data-bs-target="#staticBackdrop2"
                                  >
                                    Launch static backdrop modal
                                  </button>

                                  <div
                                    className="modal fade"
                                    id="staticBackdrop2"
                                    data-bs-backdrop="static"
                                    data-bs-keyboard="false"
                                    tabindex="-1"
                                    aria-labelledby="staticBackdrop2Label"
                                    aria-hidden="true"
                                  >
                                    <div className="modal-dialog">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h5
                                            className="modal-title"
                                            id="staticBackdrop2Label"
                                          >
                                            List
                                          </h5>
                                          <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => {
                                              setDataState1([]);
                                            }}
                                          ></button>
                                        </div>

                                        {hideSkeleton2 == true ? (
                                          <>
                                            <Box sx={{ width: "100%" }}>
                                            <Skeleton />
                                              <Skeleton animation="wave" />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                            </Box>
                                          </>
                                        ) : (
                                          <>
                                            <div
                                              className="modal-body"
                                              style={{
                                                height: "423px",
                                                overflow: "auto",
                                              }}
                                            >
                                              <div className="table-responsive">
                                                {Name1 == "accountId" && (
                                                  <>
                                                    <table className="table table-striped table-bordered dataTable table-sm">
                                                      <thead>
                                                        <tr role="row">
                                                          <th className="text-center width_2">
                                                            User Id
                                                          </th>
                                                          <th className="text-center width_2">
                                                            User Name
                                                          </th>
                                                        </tr>
                                                      </thead>

                                                      <tbody
                                                        id="dropdown-item"
                                                        role="rowgroup"
                                                      >
                                                        {dataState1?.map(
                                                          (arg) => {
                                                            return (
                                                              <>
                                                                <tr role="row">
                                                                  <td>
                                                                    {
                                                                      arg?.userId
                                                                    }
                                                                  </td>
                                                                  <td>
                                                                    {
                                                                      arg?.userName
                                                                    }
                                                                  </td>
                                                                </tr>
                                                              </>
                                                            );
                                                          }
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </>
                                                )}
                                                {Name1 == "senderId" && (
                                                  <>
                                                    <div
                                                      className="modal-body"
                                                      style={{
                                                      //  height: "423px",
                                                        overflow: "auto",
                                                      }}
                                                    >
                                                      <div className="table-responsive">
                                                        <table className="table table-striped table-bordered dataTable table-sm">
                                                          {dataState1.length ==
                                                            0 && (
                                                            <h5 className="text-center mt-4">
                                                              Data Not Found
                                                            </h5>
                                                          )}
                                                          <thead>
                                                            <tr role="row">
                                                              <th className="text-center width_2">
                                                                Id
                                                              </th>
                                                              <th className="text-center width_2">
                                                                Sender Name
                                                              </th>
                                                            </tr>
                                                          </thead>

                                                          <tbody
                                                            id="dropdown-item"
                                                            role="rowgroup"
                                                          >
                                                            {dataState1?.map(
                                                              (arg) => {
                                                                return (
                                                                  <>
                                                                    <tr role="row">
                                                                      <td>
                                                                        {arg.id}
                                                                      </td>
                                                                      <td>
                                                                        {
                                                                          arg?.senderId
                                                                        }
                                                                      </td>
                                                                    </tr>
                                                                  </>
                                                                );
                                                              }
                                                            )}
                                                          </tbody>
                                                        </table>
                                                        {/* <div className="modal-footer justify-content-center">
                                              <button
                                                type="button"
                                                className="btn btn-primary editcolor shadow okbtn"
                                                data-bs-dismiss="modal"
                                              >
                                                Ok
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-secondary shadow"
                                                data-bs-dismiss="modal"
                                              >
                                                Cancel
                                              </button>
                                            </div> */}
                                                      </div>
                                                    </div>
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* ............................................................ */}
                                <div>
                                  <button
                                    ref={PopupModalAction}
                                    type="button"
                                    className="btn btn-primary d-none"
                                    data-bs-toggle="modal"
                                    data-bs-target="#staticBackdrop3"
                                  >
                                    Launch static backdrop modal
                                  </button>

                                  <div
                                    className="modal fade"
                                    id="staticBackdrop3"
                                    data-bs-backdrop="static"
                                    data-bs-keyboard="false"
                                    tabindex="-1"
                                    aria-labelledby="staticBackdrop3Label"
                                    aria-hidden="true"
                                  >
                                    <div className="modal-dialog">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h5
                                            className="modal-title"
                                            id="staticBackdrop3Label"
                                          >
                                            List
                                          </h5>
                                          <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => {
                                              setDataState2([]);
                                            }}
                                          ></button>
                                        </div>
                                        {hideSkeleton2 == true ? (
                                          <>
                                            <Box sx={{ width: "100%" }}>
                                            <Skeleton />
                                              <Skeleton animation="wave" />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                              <Skeleton animation={false} />
                                            </Box>
                                          </>
                                        ) : (
                                          <>
                                            <div
                                              className="modal-body"
                                              style={{
                                                height: "423px",
                                                overflow: "auto",
                                              }}
                                            >
                                              <div className="table-responsive">
                                                {Name2 == "accountId" && (
                                                  <>
                                                    <table className="table table-striped table-bordered dataTable table-sm">
                                                      <thead>
                                                        <tr role="row">
                                                          <th className="text-center width_2">
                                                            User Id
                                                          </th>
                                                          <th className="text-center width_2">
                                                            User Name
                                                          </th>
                                                        </tr>
                                                      </thead>

                                                      <tbody
                                                        id="dropdown-item"
                                                        role="rowgroup"
                                                      >
                                                        {dataState2?.map(
                                                          (arg) => {
                                                            return (
                                                              <>
                                                                <tr role="row">
                                                                  <td>
                                                                    {
                                                                      arg?.userId
                                                                    }
                                                                  </td>
                                                                  <td>
                                                                    {
                                                                      arg?.userName
                                                                    }
                                                                  </td>
                                                                </tr>
                                                              </>
                                                            );
                                                          }
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </>
                                                )}

                                                {Name2 == "senderId" && (
                                                  <>
                                                    <div
                                                      className="modal-body"
                                                      style={{
                                                        // height: "423px",
                                                        overflow: "auto",
                                                      }}
                                                    >
                                                      <div className="table-responsive">
                                                        <table className="table table-striped table-bordered dataTable table-sm">
                                                          {dataState2.length ==
                                                            0 && (
                                                            <h5 className="text-center mt-4">
                                                              Data Not Found
                                                            </h5>
                                                          )}
                                                          <thead>
                                                            <tr role="row">
                                                              <th className="text-center width_2">
                                                                Id
                                                              </th>
                                                              <th className="text-center width_2">
                                                                Sender Name
                                                              </th>
                                                            </tr>
                                                          </thead>

                                                          <tbody
                                                            id="dropdown-item"
                                                            role="rowgroup"
                                                          >
                                                            {dataState2?.map(
                                                              (arg) => {
                                                                return (
                                                                  <>
                                                                    <tr role="row">
                                                                      <td>
                                                                        {arg.id}
                                                                      </td>
                                                                      <td>
                                                                        {
                                                                          arg?.senderId
                                                                        }
                                                                      </td>
                                                                    </tr>
                                                                  </>
                                                                );
                                                              }
                                                            )}
                                                          </tbody>
                                                        </table>
                                                        {/* <div className="modal-footer justify-content-center">
                                              <button
                                                type="button"
                                                className="btn btn-primary editcolor shadow okbtn"
                                                data-bs-dismiss="modal"
                                              >
                                                Ok
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-secondary shadow"
                                                data-bs-dismiss="modal"
                                              >
                                                Cancel
                                              </button>
                                            </div> */}
                                                      </div>
                                                    </div>
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                          </>
                                        )}

                                        {/* <div class="modal-footer"> */}

                                        {/* </div> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* )} */}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                </ThemeProvider>
              </div>
            </div>
          </div>
        </div>
      </main>
      <div style={{ marginLeft: "260px" }}></div>
    </>
  );
};
export default withRouter(SpamRules);

